import { memo, useContext } from 'react'

import { AppId } from '@inno-tools/container-bridge'
import { useNavigate } from 'react-router-dom'
import { UserContext } from 'shared/contexts/User'

import { useAvailableApps } from '../hooks/useAvailableApps'
import { FullPageAppTemplate } from '../templates'

const AssetManagementApp = memo(
  () => {
    const navigate = useNavigate()
    const { location } = window
    const { user } = useContext(UserContext)
    const { apps } = useAvailableApps()

    return (
      <FullPageAppTemplate
        appId={AppId.ASSET_MANAGEMENT}
        scope='asset_management'
        envKey={apps[AppId.ASSET_MANAGEMENT].runtimeEnvKey}
        entryPath='./AssetManagementApp'
        url={process.env.REACT_APP_ASSET_MANAGEMENT_APP_DEV_PATH}
        appName={apps[AppId.ASSET_MANAGEMENT].name}
        appProps={{
          user,
          initialPath: apps[AppId.ASSET_MANAGEMENT].path,
          onNavigate: ({ pathname: nextPathname }: { pathname: string }) => {
            const { pathname } = location

            if (pathname !== nextPathname) {
              navigate(nextPathname)
            }
          }
        }}
      />
    )
  },
  () => true
)

export { AssetManagementApp }
